import React, { Component } from 'react';
function Logo() {
    return (
        <div id='logo'><a href='.'>TypingTest by Quan</a></div>
      );
}

export default Logo;